/**
 * LIG — welcome popup: the Golden Design Giveaway.
 *
 * No discount, no coupon — the hook is the monthly drawing: one member's dog
 * becomes a free custom LIG design. Captures email → middleware /api/subscribe
 * (Klaviyo list Vp2c4U + consent, Shopify customer tag, giveaway pool).
 *
 * Behavior rules (deliberately conservative so it never detracts):
 *   - shows once per visitor: after 20s on page OR 45% scroll, whichever first
 *   - dismissed → snoozed 30 days; subscribed → never again
 *   - never on the concierge/chat, custom-orders, track-order pages
 *   - never on a maker page (2026-10-22: it opened at 45% scroll — right where
 *     the ornament/calendar/storybook/card/dog/name makers' forms sit). Decided
 *     by the maker's root element in the DOM (MAKER_ROOTS), so a new page or
 *     product using a maker section is covered; MAKER_PATHS is the backstop.
 *   - waits while the cart drawer, the customize modal or its save card is up
 *   - Esc / overlay click closes; email field gets focus on open
 */
(function () {
  var API = 'https://lig-fulfillment-middleware.vercel.app';
  var IMG = 'https://nkxh40u0jgaog3cb.public.blob.vercel-storage.com/lifestyle/hero-1784299299457-tv2a6o.png';
  var SNOOZE_KEY = 'lig-welcome-snooze';
  var DONE_KEY = 'lig-welcome-done';
  var BLOCKED_PATHS = ['/pages/concierge', '/pages/custom-orders', '/pages/track-order', '/challenge', '/cart'];
  // Maker pages — exact paths (a prefix would also catch e.g. /pages/christmas-cards-gallery).
  var MAKER_PATHS = [
    '/pages/custom-ornaments', '/pages/your-dog-calendar', '/pages/your-dog-storybook',
    '/pages/christmas-cards', '/pages/make-it-theirs', '/pages/personalized-gear',
    '/products/custom-design-fee', '/products/everyday-golden-quarter-zip', '/products/custom-breed-request'
  ];
  // The root element each maker section/block renders: ornament, card, calendar,
  // storybook, Make It Theirs (dog maker), personalized-gear order form, custom
  // design intake, quarter-zip wrist name, breed request, gift card builder.
  var MAKER_ROOTS = '[data-lig-om], [data-lig-cm], [data-calendar-app], .lig-book, .lig-dm, [data-pg-order], ' +
    '[data-cd-root], [data-lig-wrist], [data-lig-product], .lig-bswap, [data-gift-studio]';

  try {
    if (localStorage.getItem(DONE_KEY)) return;
    var snooze = parseInt(localStorage.getItem(SNOOZE_KEY) || '0', 10);
    if (snooze && Date.now() < snooze) return;
  } catch (e) { return; } // no storage (private mode edge) → don't nag repeatedly
  var path = location.pathname.replace(/\/+$/, '').toLowerCase();
  for (var i = 0; i < BLOCKED_PATHS.length; i++) if (path.indexOf(BLOCKED_PATHS[i]) === 0) return;
  if (MAKER_PATHS.indexOf(path) !== -1) return;

  function onMakerPage() {
    try { return !!document.querySelector(MAKER_ROOTS); } catch (e) { return false; }
  }
  if (onMakerPage()) return; // deferred script: the server-rendered page is parsed by now

  var shown = false;

  // Someone shopping is never interrupted: once anything is added to the cart this visit, skip the giveaway.
  var shopping = false;
  document.addEventListener('cart:update', function () { shopping = true; });
  function busy() {
    if (document.querySelector('dialog[open]')) return true; // Quick shop, size guide, any open sheet
    if (document.querySelector('.lig-czsave')) return true;
    if (document.querySelector('[data-cz-modal]:not([hidden])')) return true;
    var drawer = document.querySelector('cart-drawer-component dialog[open], cart-drawer-component[open]');
    return !!drawer;
  }

  function show() {
    if (shown) return;
    if (onMakerPage()) { shown = true; return; } // a maker mounted after load — stay away
    if (shopping) { shown = true; return; }
    if (busy()) { setTimeout(show, 8000); return; }
    shown = true;

    var wrap = document.createElement('div');
    wrap.className = 'lig-welcome';
    wrap.innerHTML =
      '<div class="lig-welcome__overlay"></div>' +
      '<div class="lig-welcome__card" role="dialog" aria-modal="true" aria-label="Golden Design Giveaway">' +
        '<button type="button" class="lig-welcome__x" aria-label="Close">&times;</button>' +
        '<div class="lig-welcome__img" style="background-image:url(\'' + IMG + '\')"></div>' +
        '<div class="lig-welcome__body">' +
          '<div class="lig-welcome__eyebrow">The Monthly Giveaway</div>' +
          '<h2 class="lig-welcome__h">Your dog,<br/><em>drawn golden.</em></h2>' +
          '<p class="lig-welcome__p">Every month, one member’s pup becomes a hand-finished Life Is Golden design — <strong>free</strong>. One good photo is all it takes.</p>' +
          '<form class="lig-welcome__form" novalidate>' +
            '<input class="lig-welcome__hp" type="text" name="website" tabindex="-1" autocomplete="off" aria-hidden="true" />' +
            '<input class="lig-welcome__in" type="email" inputmode="email" autocomplete="email" placeholder="you@email.com" required />' +
            '<button class="lig-welcome__go" type="submit">Design My Dog — Free</button>' +
          '</form>' +
          '<button type="button" class="lig-welcome__decline">No thanks — I’ll pass on free gear</button>' +
          '<div class="lig-welcome__note">Winners announced the 1st · new drops first · no spam, ever. <a href="/pages/giveaway-terms" target="_blank" rel="noopener">Terms</a></div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(wrap);
    requestAnimationFrame(function () { wrap.classList.add('is-in'); });

    var input = wrap.querySelector('.lig-welcome__in');
    if (window.matchMedia('(min-width: 641px)').matches) setTimeout(function () { input.focus(); }, 450);

    function close(permanent) {
      try {
        if (permanent) localStorage.setItem(DONE_KEY, '1');
        else localStorage.setItem(SNOOZE_KEY, String(Date.now() + 30 * 86400 * 1000));
      } catch (e) { /* ok */ }
      wrap.classList.remove('is-in');
      setTimeout(function () { wrap.remove(); }, 320);
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) { if (e.key === 'Escape') close(false); }
    document.addEventListener('keydown', onKey);
    wrap.querySelector('.lig-welcome__x').addEventListener('click', function () { close(false); });
    wrap.querySelector('.lig-welcome__decline').addEventListener('click', function () { close(false); });
    wrap.querySelector('.lig-welcome__overlay').addEventListener('click', function () { close(false); });

    wrap.querySelector('form').addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { input.classList.add('is-err'); input.focus(); return; }
      input.classList.remove('is-err');
      var go = wrap.querySelector('.lig-welcome__go');
      go.disabled = true; go.textContent = 'Joining…';
      fetch(API + '/api/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, source: 'welcome-popup-giveaway', website: wrap.querySelector('.lig-welcome__hp').value }),
      }).then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.d && res.d.error) || 'try again in a minute');
          try { localStorage.setItem(DONE_KEY, '1'); } catch (e) { /* ok */ }
          var body = wrap.querySelector('.lig-welcome__body');
          body.innerHTML =
            '<div class="lig-welcome__eyebrow">You’re in</div>' +
            '<h2 class="lig-welcome__h">This drawing has<br/><em>your dog’s name on it.</em></h2>' +
            '<p class="lig-welcome__p">Winners hear from us the 1st, right in your inbox. While you wait — see what happens when we draw someone’s dog golden.</p>' +
            '<div class="lig-welcome__row">' +
              '<a class="lig-welcome__go" href="/pages/personalized-gear">See custom pieces &rarr;</a>' +
              '<button type="button" class="lig-welcome__ghost">Keep browsing</button>' +
            '</div>';
          body.querySelector('.lig-welcome__ghost').addEventListener('click', function () { close(true); });
        })
        .catch(function (err) {
          go.disabled = false; go.textContent = 'Design My Dog — Free';
          var note = wrap.querySelector('.lig-welcome__note');
          note.textContent = (err && err.message) || 'Couldn’t sign you up — try again.';
          note.classList.add('is-err');
        });
    });
  }

  setTimeout(show, 20000);
  var fired = false;
  window.addEventListener('scroll', function () {
    if (fired || shown) return;
    var h = document.documentElement;
    var depth = (h.scrollTop + window.innerHeight) / h.scrollHeight;
    if (depth > 0.45) { fired = true; show(); }
  }, { passive: true });
})();
